import styled from 'styled-components'

export const StyledNewsPageViewSwitch = styled.div`
  display: flex;
  column-gap: 8px;
`
